export default __webpack_public_path__ + "static/media/scritta.5d1ef7eb.png";